import { render, staticRenderFns } from "./VerifyUserAlert.vue?vue&type=template&id=1b4c9104&"
import script from "./VerifyUserAlert.vue?vue&type=script&lang=js&"
export * from "./VerifyUserAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports